import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Submit" button — thin `Button` wrapper defaulting `type="submit"`,
 * `variant="filled"`, and its label to "Submit".
 * @registry Primary form-submit action button.
 *
 * Ported from `library-m/components/buttons/SubmitButton`. Prop surface
 * kept identical (all `Button` props pass through, `type` and `children`
 * default but can still be overridden).
 */
export type SubmitButtonProps = ButtonProps;

export const SubmitButton = ({
  type = 'submit',
  variant = 'filled',
  children = 'Submit',
  ...props
}: SubmitButtonProps) => (
  <Button type={type} variant={variant} {...props}>
    {children}
  </Button>
);
